import { DATA_VIEW_PAGES } from './dataViewPages';

interface UrlInfo {
  path: string;
  build: (...args: any[]) => string;
  label: string;
}

// 데이터 조회 화면 URL 은 DATA_VIEW_PAGES 에서 만든다. 여기에 직접 추가하지 말 것.
const dataViewUrls: Record<string, UrlInfo> = Object.fromEntries(
  Object.entries(DATA_VIEW_PAGES).map(([key, { path, label }]) => [
    key,
    { path, build: () => path, label },
  ]),
);

export const Urls: Record<string, UrlInfo> = {
  main: {
    path: '/',
    build: () => '/',
    label: 'Home',
  },
  ...dataViewUrls,
  permissionManagement: {
    path: '/permission-management',
    build: () => '/permission-management',
    label: '역할 관리',
  },
  menuManagement: {
    path: '/menu-management',
    build: () => '/menu-management',
    label: '메뉴 관리',
  },
  userPermission: {
    path: '/user-permission',
    build: () => '/user-permission',
    label: '사용자 역할 부여',
  },
  // /api-catalog(첫 화면), /api-catalog/:task(API 하나)
  apiCatalog: {
    path: '/api-catalog',
    build: (task?: string) => ['/api-catalog', task].filter(Boolean).join('/'),
    label: 'D365 API',
  },
  // /internal-api/:code(시스템 첫 화면), /internal-api/:code/:task(할 일 화면)
  internalApi: {
    path: '/internal-api',
    build: (code?: string, task?: string) =>
      ['/internal-api', code, task].filter(Boolean).join('/'),
    label: '사내 API',
  },
  apiKeyOverview: {
    path: '/api-key-overview',
    build: () => '/api-key-overview',
    label: 'API 키 현황',
  },
  apiKeys: {
    path: '/settings/api-keys',
    build: () => '/settings/api-keys',
    label: 'API 키',
  },
} as const;

export type URL_KEY = keyof typeof Urls;
export type URL_VAL = (typeof Urls)[URL_KEY];
